import { VueApp } from '@/setup/CreateApp'

import Toast, { PluginOptions, POSITION } from "vue-toastification";
import 'vue-toastification/dist/index.css'

const options: PluginOptions = {
    position: POSITION.TOP_CENTER
}

VueApp.use(Toast, options);